import { styled as c } from "@mui/material";
import m from "../../assets/icon-user-profile.png.js";
import a from "../../../temp-lib/components/share/next/Image.js";
import { useAccountContext as i } from "../../../temp-lib/contexts/account/AccountContext.js";
import * as n from "ramda";
import { jsx as p } from "react/jsx-runtime";
const f = c(a)`
  align-items: center;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  width: 150px;
`, N = (o) => {
  const {
    className: r
  } = o, {
    account: e
  } = i(), {
    avatar: t
  } = e, s = n.isEmpty(t) ? m : t;
  return /* @__PURE__ */ p(f, {
    className: r,
    src: s,
    priority: !0
  });
};
export {
  N as default
};
//# sourceMappingURL=PlayerIcon.js.map
